/* eslint-disable @typescript-eslint/no-explicit-any */
import { IRListItem } from '@rhybus/api'

import {
  ALL_SELECT_VALUE,
  ALL_SELECT_VALUE_STRING,
  MPF_ACTIVE_INQUIRY_KPI,
} from '../../../../utils/constants/global-constants'
import { PersonDetails, UserID } from '../../../../utils/constants/global-interfaces'
import { mpfRListsHttp } from '../../api/mpf-r-lists-http'
import { mpfRViewsHttp } from '../../api/mpf-views-http'
import { formatStringForServer } from '../../formatting/formatting'
import { getFilteredDates } from '../../general/general'
import { and, isArchivedFilter, or } from '../data'
import { STATUS_CODE } from './inquiry-status-metadata'

type InquiryType = '' | 'Other' | 'Self'

interface Inquiry {
  ArchivedDate?: Date | null | string
  'AssignedComponent/MetadataValue'?: string
  AssignedComponentCode: null | number
  AssignedTo?: PersonDetails | string
  'AssignedTo/edipi'?: string
  'AssignedTo/email'?: string
  'AssignedTo/firstname'?: string
  'AssignedTo/lastname'?: string
  CanceledDate?: Date | null | string
  'Category/MetadataValue'?: string
  CategoryCode: null | number
  ClosedDate?: Date | null | string
  CurrentlyServicingBy?: string
  Customer?: PersonDetails | UserID | string
  'Customer/edipi'?: string
  'Customer/email'?: string
  'Customer/firstname'?: string
  'Customer/lastname'?: string
  CustomerActionRequired?: boolean
  CustomerActionRequiredDate?: Date | null | string
  CustomerName?: string
  CustomerStatus: string
  Description: string
  DoDNumber: string
  DutyEmail: string
  DutyPhone: string
  FY?: number
  InquiryGUID?: string
  InquiryID?: null | number | string
  InquiryType: InquiryType
  Installation?: string
  InvolvedUsers?: string[]
  IsArchived?: boolean
  ItemCreated?: Date
  ItemCreatedBy?: any
  'ItemCreatedBy/edipi'?: string
  'ItemCreatedBy/email'?: string
  'ItemCreatedBy/firstname'?: string
  'ItemCreatedBy/lastname'?
  ItemModified?: Date
  ItemModifiedBy?: any
  'ItemModifiedBy/edipi'?: string
  'ItemModifiedBy/email'?: string
  'ItemModifiedBy/firstname'?: string
  'ItemModifiedBy/latname'?: string
  OrgMAJCOM: string
  Organization: string
  PASCODE?: string
  PASCODEServicedBy?: string
  PendingActionOutside?: boolean
  PendingActionOutsideDate?: Date | null | string
  PersonalEmail?: string
  PersonalPhoneNumber?: string
  PersonalPhoneProvider?: string
  'PreviousCategory/MetadataValue'?: string
  PreviousCategoryCode?: number
  'PreviousSection/MetadataValue'?: string
  PreviousSectionCode?: number
  'PreviousStatus/MetadataValue'?: string
  PreviousStatusCode?: string
  'PreviousSubCategory/MetadataValue'?
  PreviousSubCategoryCode?: number
  Priority?: string
  Rank: string
  ReopenedDate?: Date | null | string
  ResolvedDate?: Date | null | string
  ResponseRequired?: boolean
  'Section/MetadataValue': string
  SectionCode: null | number
  ServicingBy?: string
  'ServicingMAJCOM/MetadataValue'?: string
  ServicingMAJCOMCode: null | number
  ServicingOrganization?: string
  'Status/StatusDescription'?: string
  StatusCode: string
  'SubCategory/MetadataValue'?: string
  SubCategoryCode: null | number
  Subject: string
  TeamMembers?: PersonDetails[]
  eKey?: string
  eTag?: string
}
interface InquiryCount {
  InquiryGUID_count: number
}
interface InquiryCategoryCount {
  InquiryGUID_count: number
  category: string
}
interface month {
  month: number
  reopenedCount: number
  resolvedCount: number
  submittedCount: number
  year: number
}

interface InquiryCategoryCount {
  category: string
  count: number
}

interface InquiryStatusCount {
  InquiryGUID_count: number
  StatusCode: string
}

interface InquiryFiles {
  DocumentTitle?: string
  createdBy: string
  createdOn: Date
  eKey: string
  eTag: string
  fileName: string
  folderName: string
  modifiedBy: string
  modifiedOn: Date
}
type IsForSelf = boolean

type FilteredDatesType =
  | 'Last 3 days'
  | 'Last 7 days'
  | 'Last 15 days'
  | 'Last 24 hours'
  | 'Last 30 days'
  | 'Last 48 hours'
  | 'More than 30 days'

interface LoginRoles {
  CSSPASCODEFilter?: string[]
  usersAssignedComponentCode?: number[]
  usersMajcomCodeFilter?: number[]
  usersSectionCodeFilter?: number[]
  usersServicingOrganizationFilter?: string[]
  usersServicingOrganizationWithoutSectionFilter?: string[]
}

interface InquiryFetchArgs {
  // CSSPASCODEFilter?: any
  activeFilter?: boolean
  archivedFilter?: string
  archivedsearchFilter?: string
  assignedComponentCodeFilter?: number
  assignedToLocationFilter?: any
  assignedToMe?: string
  assignedToOther?: string
  assignedToUsersFilter?: any
  categories?: any
  categoryCodeFilter?: number
  categoryFilter?: null | number | string
  currentSection?: boolean
  currentlyServicingByFilter?: string
  customerActionRequiredFilter?: boolean | null
  customerActionRequiredMoreThanTenDaysFilter?: boolean | null
  customerActionRequiredSevenDaysFilter?: boolean | null
  customerActionRequiredTenDaysFilter?: boolean | null
  customerActionRequiredThreeDaysFilter?: boolean | null
  customerFilter?: string
  distinctFiltersToQuery?: string[]
  elevatedToMPF?: boolean
  groupByArgs?: string[]
  hasCanceledClosedAndResolved?: boolean
  inquiryGuid?: string
  inquiryTypeFilter?: InquiryType
  isArchivedFilter?: false | null | true
  isAscending?: boolean
  isCPOwnerOrLeadership?: boolean
  isReopened?: boolean
  isResponsePending?: boolean
  isResponseRequired?: boolean | null
  isSavedInquiryDeleted?: boolean
  isSubmitted?: boolean
  isViewApplied?: boolean
  itemCreatedByFilter?: string
  myInquiries?: string
  needToWorkFilter?: boolean | null
  notSelfFilter?: string
  onePageOnly?: boolean
  options?: any
  orderBy?: string
  organizationFilter?: null | string
  otherFilter?: null | string
  pageNumber?: number
  pendingActionOutsideFilter?: boolean | null
  pendingActionOutsideMoreThanTenFilter?: boolean | null
  pendingActionOutsideSevenDaysFilter?: boolean | null
  pendingActionOutsideTenDaysFilter?: boolean | null
  pendingActionOutsideThreeDaysFilter?: boolean | null
  priorityFilter?: any
  refresh?: boolean
  relatedUserFilter?: null | string
  resolvedClosedDateFilter?: null | string
  responsePending?: boolean
  returnedFromMPF?: boolean
  savedFilter?: boolean
  searchFilter?: null | string
  sectionCodeFilter?: null | number
  sectionCodeKPIFilter?: null | number
  sectionFilter?: null | number | string
  selectArgs?: string[]
  selfFilter?: null | string
  servicingByFilter?: string
  servicingMAJCOMCodeFilter?: number
  servicingOrganizationFilter?: number | string
  statusCodeFilter?: string
  statusCodesFilter?: string[]
  statusCodesOmittedFilter?: string[]
  subCategoryCodeFilter?: number
  subCategoryFilter?: null | number | string
  submittedFilter?: null | string
  unassignedFilter?: boolean
  userLoginRole?: LoginRoles
  userRole?: null | string
  waitOnParentDependency?: boolean
  yearFilter?: number
}
// Warning -- page size should never be set so low that a full page of
// inquiries is displayed in the table with no scrollbar present.
// If this happens the user won't have a way to trigger additional page
// loads on scroll.
const PAGE_SIZE = 100
const LIST_NAME = 'InquiryList'
const VIEW_NAME = 'V_InquiryList'
const COLUMN_NAMES = {
  ArchivedDate: 'ArchivedDate',
  AssignedComponent: 'AssignedComponent/MetadataValue',
  AssignedComponentCode: 'AssignedComponentCode',
  AssignedTo: 'AssignedTo',
  AssignedToEDIPI: 'AssignedTo/edipi',
  AssignedToEmail: 'AssignedTo/email',
  AssignedToFirstName: 'AssignedTo/firstname',
  AssignedToLastName: 'AssignedTo/lastname',
  CanceledDate: 'CanceledDate',
  Category: 'Category/MetadataValue',
  CategoryCode: 'CategoryCode',
  ClosedDate: 'ClosedDate',
  CurrentlyServicingBy: 'CurrentlyServicingBy',
  Customer: 'Customer',
  CustomerActionRequired: 'CustomerActionRequired',
  CustomerActionRequiredDate: 'CustomerActionRequiredDate',
  CustomerEDIPI: 'Customer/edipi',
  CustomerEmail: 'Customer/email',
  CustomerFirstName: 'Customer/firstname',
  CustomerLastName: 'Customer/lastname',
  CustomerStatus: 'CustomerStatus',
  Description: 'Description',
  DoDNumber: 'DoDNumber',
  DutyEmail: 'DutyEmail',
  DutyPhone: 'DutyPhone',
  ETag: 'eTag',
  Ekey: 'eKey',
  FY: 'FY',
  InquiryGUID: 'InquiryGUID',
  InquiryID: 'InquiryID',
  InquiryType: 'InquiryType',
  Installation: 'Installation',
  InvolvedUsers: 'InvolvedUsers',
  IsArchived: 'IsArchived',
  IsDeleted: 'IsDeleted',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemCreatedByEDIPI: 'ItemCreatedBy/edipi',
  ItemCreatedByEmail: 'ItemCreatedBy/email',
  ItemCreatedByFirstName: 'ItemCreatedBy/firstname',
  ItemCreatedByLastName: 'ItemCreatedBy/lastname',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ItemModifiedByEDIPI: 'ItemModifiedBy/edipi',
  ItemModifiedByEmail: 'ItemModifiedBy/email',
  ItemModifiedByFirstName: 'ItemModifiedBy/firstname',
  ItemModifiedByLastName: 'ItemModifiedBy/lastname',
  OrgMAJCOM: 'OrgMAJCOM',
  Organization: 'Organization',
  PASCODE: 'PASCODE',
  PASCODEServicedBy: 'PASCODEServicedBy',
  PascodeID: 'PascodeID',
  PendingActionOutside: 'PendingActionOutside',
  PendingActionOutsideDate: 'PendingActionOutsideDate',
  PersonalEmail: 'PersonalEmail',
  PersonalPhoneNumber: 'PersonalPhoneNumber',
  PersonalPhoneProvider: 'PersonalPhoneProvider',
  PreviousCategory: 'PreviousCategory/MetadataValue',
  PreviousCategoryCode: 'PreviousCategoryCode',
  PreviousSection: 'PreviousSection/MetadataValue',
  PreviousSectionCode: 'PreviousSectionCode',
  PreviousStatus: 'PreviousStatus/StatusDescription',
  PreviousStatusCode: 'PreviousStatusCode',
  PreviousSubCategory: 'PreviousSubCategory/MetadataValue',
  PreviousSubCategoryCode: 'PreviousSubCategoryCode',
  Priority: 'Priority',
  Rank: 'Rank',
  ReopenedDate: 'ReopenedDate',
  ResolvedDate: 'ResolvedDate',
  ResponseRequired: 'ResponseRequired',
  Section: 'Section/MetadataValue',
  SectionCode: 'SectionCode',
  ServicingBy: 'ServicingBy',
  ServicingMAJCOM: 'ServicingMAJCOM/MetadataValue',
  ServicingMAJCOMCode: 'ServicingMAJCOMCode',
  ServicingOrganization: 'ServicingOrganization',
  Status: 'Status/StatusDescription',
  StatusCode: 'StatusCode',
  SubCategory: 'SubCategory/MetadataValue',
  SubCategoryCode: 'SubCategoryCode',
  Subject: 'Subject',
  TeamMembers: 'TeamMembers',
}
const getInquiries = async (args: InquiryFetchArgs): Promise<Inquiry[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = constructInquiryFilter(args)
  const pageNum = args.pageNumber ?? -1
  const onePageOnly = args.onePageOnly ?? true
  const orderBy = args.orderBy ?? COLUMN_NAMES.ItemModified
  const ascending = args.isAscending ?? false

  const query = list
    .query()
    .select(...Object.values(COLUMN_NAMES))
    .filter(filter)
    .expand(
      'AssignedComponent',
      'ServicingMAJCOM',
      'AssignedTo',
      'Category',
      'Customer',
      'ItemCreatedBy',
      'ItemModifiedBy',
      'PreviousStatus',
      'PreviousCategory',
      'PreviousSection',
      'PreviousSubCategory',
      'Section',
      'Status',
      'SubCategory',
      'TeamMembers'
    )
    .orderBy([{ ascending, orderBy }])

  // If a page number is supplied, skip to fetch starting at that page number
  const startAtPageQuery = pageNum > -1 ? query.skip(pageNum * PAGE_SIZE) : query

  // If onePageOnly is set to true, only fetch one page of data, otherwise
  // fetch all
  const oneOrManyPagesQuery = onePageOnly ? startAtPageQuery.top(PAGE_SIZE) : startAtPageQuery

  const items = await oneOrManyPagesQuery.get()
  const convertedItems = [...items].map((i) => convertDatesInServerObject(i))
  return convertedItems
}
const getInquiryViews = async (args: InquiryFetchArgs): Promise<Inquiry[]> => {
  const list = await mpfRViewsHttp().getview(VIEW_NAME)
  const filter = constructInquiryFilter(args, true)
  const pageNum = args.pageNumber ?? -1
  const onePageOnly = args.onePageOnly ?? true
  const orderBy = args.orderBy ?? COLUMN_NAMES.ItemModified
  const ascending = args.isAscending ?? false
  const query = list.query().filter(filter).orderBy([{ ascending, orderBy }])
  const startAtPageQuery = pageNum > -1 ? query.skip(pageNum * PAGE_SIZE) : query
  const oneOrManyPagesQuery = onePageOnly ? startAtPageQuery.top(PAGE_SIZE) : startAtPageQuery

  const items = await oneOrManyPagesQuery.get()
  const convertedItems = [...items].map((i) => convertDatesInServerObject(i))
  return convertedItems
}
const convertDatesInServerObject = (item: IRListItem): Inquiry => {
  const inquiry = item as Inquiry
  const todate = (d) => (d ? new Date(d) : null)

  return {
    ...inquiry,
    CanceledDate: todate(inquiry.CanceledDate),
    ClosedDate: todate(inquiry.ClosedDate),
    CustomerActionRequiredDate: todate(inquiry.CustomerActionRequiredDate),
    ItemCreated: todate(inquiry.ItemCreated) ?? new Date(),
    ItemModified: todate(inquiry.ItemModified) ?? new Date(),
    PendingActionOutsideDate: todate(inquiry.PendingActionOutsideDate),
    ReopenedDate: todate(inquiry.ReopenedDate),
    ResolvedDate: todate(inquiry.ResolvedDate),
  }
}

const constructInquiryFilter = (args: InquiryFetchArgs, isView?: boolean): string => {
  const filters: string[] = []
  filters.push(isArchivedFilter(args.isArchivedFilter ?? null))
  if (args.searchFilter && args.searchFilter !== ALL_SELECT_VALUE_STRING && isView) {
    //This will need to change in the future from startswith to contains, however currently contains is yet to be implemented.
    filters.push(
      `(contains(InquiryID, '${formatStringForServer(
        args.searchFilter,
        'single-quotes'
      )}') or contains(Subject, '${formatStringForServer(
        args.searchFilter,
        'single-quotes'
      )}') or contains(DutyEmail, '${formatStringForServer(
        args.searchFilter,
        'single-quotes'
      )}')or contains(DoDNumber, '${formatStringForServer(
        args.searchFilter,
        'single-quotes'
      )}') or contains(CustomerName, '${formatStringForServer(
        args.searchFilter,
        'single-quotes'
      )}'))`
    )
  } else if (args.searchFilter && args.searchFilter !== ALL_SELECT_VALUE_STRING) {
    //This will need to change in the future from startswith to contains, however currently contains is yet to be implemented.
    filters.push(
      `(contains(InquiryID, '${formatStringForServer(
        args.searchFilter,
        'single-quotes'
      )}') or contains(Subject, '${formatStringForServer(
        args.searchFilter,
        'single-quotes'
      )}') or contains(DutyEmail, '${formatStringForServer(args.searchFilter, 'single-quotes')}'))`
    )
  }
  if (args.archivedsearchFilter && args.archivedsearchFilter !== ALL_SELECT_VALUE_STRING) {
    filters.push(
      `(contains(InquiryID, '${formatStringForServer(
        args.archivedsearchFilter,
        'single-quotes'
      )}') or contains(ServicingOrganization, '${formatStringForServer(
        args.archivedsearchFilter,
        'single-quotes'
      )}') or contains(Subject, '${formatStringForServer(
        args.archivedsearchFilter,
        'single-quotes'
      )}')  or contains(SectionValue, '${formatStringForServer(
        args.archivedsearchFilter,
        'single-quotes'
      )}')  or contains(CustomerName, '${formatStringForServer(
        args.archivedsearchFilter,
        'single-quotes'
      )}') or contains(CategoryValue, '${formatStringForServer(
        args.archivedsearchFilter,
        'single-quotes'
      )}') or contains(SubCategoryValue, '${formatStringForServer(
        args.archivedsearchFilter,
        'single-quotes'
      )}') or contains(DutyEmail, '${formatStringForServer(
        args.archivedsearchFilter,
        'single-quotes'
      )}'))`
    )
  }
  if (args.yearFilter && args.yearFilter !== ALL_SELECT_VALUE) {
    filters.push(`FY eq ${args.yearFilter}`)
  }
  if (args.selfFilter) {
    filters.push(`Customer eq '${args.selfFilter}'`)
  }
  if (args.notSelfFilter) {
    filters.push(`Customer ne '${args.notSelfFilter}'`)
  }
  if (args.otherFilter) {
    filters.push(`Customer ne '${args.otherFilter}'`)
    filters.push(`ItemCreatedBy eq '${args.otherFilter}'`)
  }

  if (args.currentlyServicingByFilter) {
    filters.push(`CurrentlyServicingBy eq '${args.currentlyServicingByFilter}'`)
  }
  if (
    args.servicingOrganizationFilter &&
    args.servicingOrganizationFilter !== ALL_SELECT_VALUE_STRING &&
    args.servicingOrganizationFilter !== ALL_SELECT_VALUE
  ) {
    filters.push(`ServicingOrganization eq '${args.servicingOrganizationFilter}'`)
  }
  if (args.relatedUserFilter && args.relatedUserFilter !== undefined) {
    const userFilter = or(
      `Customer eq '${args.relatedUserFilter}'`,
      `ItemCreatedBy eq '${args.relatedUserFilter}'`
    )
    filters.push(userFilter)
  }

  if (args.organizationFilter && args.organizationFilter !== ALL_SELECT_VALUE_STRING) {
    filters.push(`Organization eq '${args.organizationFilter}'`)
  }

  if (args.categoryCodeFilter && args.categoryCodeFilter !== ALL_SELECT_VALUE) {
    filters.push(`CategoryCode eq ${args.categoryCodeFilter}`)
  }
  if (args.subCategoryCodeFilter !== undefined && args.subCategoryCodeFilter !== ALL_SELECT_VALUE) {
    filters.push(`SubCategoryCode eq ${args.subCategoryCodeFilter}`)
  }
  if (args.priorityFilter && args.priorityFilter !== ALL_SELECT_VALUE_STRING) {
    filters.push(`Priority eq ${args.priorityFilter}`)
  }
  if (args.submittedFilter && args.submittedFilter !== ALL_SELECT_VALUE_STRING) {
    filters.push(
      `ItemCreated ${args.submittedFilter === 'More than 30 days' ? 'lt' : 'ge'} ${getFilteredDates(
        args.submittedFilter as FilteredDatesType
      )}`
    )
  }
  if (args.archivedFilter && args.archivedFilter !== ALL_SELECT_VALUE_STRING) {
    filters.push(
      ` ArchivedDate  ${
        args.archivedFilter === 'More than 30 days' ? 'lt' : 'ge'
      } ${getFilteredDates(args.archivedFilter as FilteredDatesType)}`
    )
  }

  if (
    args.userLoginRole &&
    Object.values(args.userLoginRole).some((arr) => Array.isArray(arr) && arr.length > 0)
  ) {
    const componentFilters: string[] = []
    const roleFilters: string[] = []
    if (
      Array.isArray(args.userLoginRole.usersAssignedComponentCode) &&
      args.userLoginRole.usersAssignedComponentCode.length > 0
    ) {
      const assignCompFilter = args.userLoginRole.usersAssignedComponentCode.map(
        (component) => `AssignedComponentCode eq ${component}`
      )
      componentFilters.push(or(...assignCompFilter))
      roleFilters.push(or(...assignCompFilter))
    }
    if (
      componentFilters.length === 0 &&
      Array.isArray(args.userLoginRole.usersMajcomCodeFilter) &&
      args.userLoginRole.usersMajcomCodeFilter.length > 0
    ) {
      const assignCompFilter = args.userLoginRole.usersMajcomCodeFilter.map(
        (majcom) => `ServicingMAJCOMCode eq ${majcom}`
      )
      roleFilters.push(or(...assignCompFilter))
    }
    if (
      componentFilters.length === 0 &&
      Array.isArray(args.userLoginRole.usersServicingOrganizationFilter) &&
      Array.isArray(args.userLoginRole.usersSectionCodeFilter) &&
      args.userLoginRole.usersServicingOrganizationFilter.length > 0 &&
      args.userLoginRole.usersSectionCodeFilter.length > 0
    ) {
      const servicingOrgFilter = args.userLoginRole.usersServicingOrganizationFilter.map((s, i) => {
        const sectionCode = args?.userLoginRole?.usersSectionCodeFilter?.[i]
        return `(ServicingOrganization eq '${s}' and (SectionCode eq ${
          sectionCode ?? 'null'
        } or ( PreviousSectionCode eq ${sectionCode ?? 'null'} and ResponseRequired eq true)) )`
      })

      roleFilters.push(or(...servicingOrgFilter))
    }
    if (
      componentFilters.length === 0 &&
      Array.isArray(args.userLoginRole.usersServicingOrganizationWithoutSectionFilter) &&
      args.userLoginRole.usersServicingOrganizationWithoutSectionFilter.length > 0
    ) {
      const servicingOrgFilter =
        args.userLoginRole.usersServicingOrganizationWithoutSectionFilter.map((s) => {
          return `(ServicingOrganization eq '${s}')`
        })

      roleFilters.push(or(...servicingOrgFilter))
    }

    if (
      Array.isArray(args.userLoginRole.CSSPASCODEFilter) &&
      args.userLoginRole.CSSPASCODEFilter.length > 0
    ) {
      const cssPascodeFilter = args.userLoginRole.CSSPASCODEFilter.map(
        (pascode) => `PASCODE eq '${pascode}' and ServicingBy eq 'CSS'`
      )
      roleFilters.push(or(...cssPascodeFilter))
    }
    filters.push(or(...roleFilters))
  }

  if (args.assignedComponentCodeFilter && args.assignedComponentCodeFilter !== ALL_SELECT_VALUE) {
    filters.push(`AssignedComponentCode eq ${args.assignedComponentCodeFilter}`)
  }

  if (args.categoryCodeFilter && args.categoryCodeFilter !== ALL_SELECT_VALUE) {
    filters.push(`CategoryCode eq ${args.categoryCodeFilter}`)
  }

  if (args.servicingMAJCOMCodeFilter && args.servicingMAJCOMCodeFilter !== ALL_SELECT_VALUE) {
    filters.push(`ServicingMAJCOMCode eq ${args.servicingMAJCOMCodeFilter}`)
  }

  if (args.customerFilter && args.customerFilter !== ALL_SELECT_VALUE_STRING) {
    filters.push(`Customer eq '${args.customerFilter}'`)
  }

  if (args.itemCreatedByFilter && args.itemCreatedByFilter !== ALL_SELECT_VALUE_STRING) {
    filters.push(`ItemCreatedBy eq '${args.itemCreatedByFilter}'`)
  }

  if (args.servicingByFilter && args.servicingByFilter !== ALL_SELECT_VALUE_STRING) {
    filters.push(`ServicingBy eq '${args.servicingByFilter}'`)
  }
  if (args.assignedToLocationFilter && args.assignedToLocationFilter !== ALL_SELECT_VALUE_STRING) {
    filters.push(`Installation eq '${args.assignedToLocationFilter}'`)
  }

  if (args.statusCodeFilter && args.statusCodeFilter !== ALL_SELECT_VALUE_STRING) {
    filters.push(`StatusCode eq '${args.statusCodeFilter}'`)
  }

  if (args.inquiryGuid) {
    filters.push(`InquiryGUID eq '${args.inquiryGuid}'`)
  }
  if (args.resolvedClosedDateFilter && args.resolvedClosedDateFilter !== ALL_SELECT_VALUE_STRING) {
    filters.push(
      `( ResolvedDate  ${
        args.resolvedClosedDateFilter === 'More than 30 days' ? 'lt' : 'ge'
      } ${getFilteredDates(args.resolvedClosedDateFilter as FilteredDatesType)} or ClosedDate  ${
        args.resolvedClosedDateFilter === 'More than 30 days' ? 'lt' : 'ge'
      } ${getFilteredDates(args.resolvedClosedDateFilter as FilteredDatesType)}) `
    )
  }
  /** KPIs */
  /** Section KPI */

  /** All */

  // Handle sectionCodeFilter
  if (
    args.sectionCodeFilter &&
    !Array.isArray(args.sectionCodeFilter) &&
    args.sectionCodeFilter > 0
  ) {
    filters.push(`SectionCode eq ${args.sectionCodeFilter}`)
  }

  // Handle sectionCodeKPIFilter
  if (
    args.sectionCodeKPIFilter &&
    !Array.isArray(args.sectionCodeKPIFilter) &&
    args.sectionCodeKPIFilter > 0 &&
    (!args.isResponseRequired || args.isResponsePending)
  ) {
    filters.push(`SectionCode eq ${args.sectionCodeKPIFilter}`)
  }

  /** Unassigned */
  if (args.unassignedFilter) {
    filters.push(
      `(StatusCode eq '${STATUS_CODE.SUBMITTED}' or StatusCode eq '${STATUS_CODE.REOPENED}')`
    )
  }
  if (args?.assignedToMe && args?.assignedToMe !== null && args?.assignedToMe !== '') {
    filters.push(`AssignedTo eq '${args?.assignedToMe}'`)
  }
  if (args?.assignedToOther && args?.assignedToOther !== null && args?.assignedToOther !== '') {
    filters.push(`AssignedTo ne '${args?.assignedToOther}' and AssignedTo ne 'NULL'`)
  }
  if (args?.assignedToUsersFilter && args?.assignedToUsersFilter !== ALL_SELECT_VALUE_STRING) {
    filters.push(`AssignedTo eq '${args?.assignedToUsersFilter}' `)
  }

  if (args.isSubmitted) {
    filters.push(`StatusCode eq 'SUBMITTED'`)
  }
  if (args.isReopened) {
    filters.push(`StatusCode eq 'REOPENED'`)
  }

  /** Response Required */
  if (args.isResponseRequired) {
    //Owners and Leaders can see every Response KPI
    if (args.isCPOwnerOrLeadership) {
      filters.push(`ResponseRequired eq true`)
      if (!args.isResponsePending) {
        if (args.sectionCodeKPIFilter && Array.isArray(args.sectionCodeKPIFilter)) {
          filters.push(`PreviousSectionCode in (${args.sectionCodeKPIFilter.join(', ')})`)
        } else {
          filters.push(`PreviousSectionCode eq ${args.sectionCodeKPIFilter}`)
        }
      }
    } else {
      if (args.currentSection && !args.isResponsePending) {
        filters.push(
          `ResponseRequired eq ${args.isResponseRequired} and SectionCode eq ${args.currentSection} `
        )
      }
      if (args.currentSection && args.isResponsePending) {
        filters.push(
          `ResponseRequired eq ${args.isResponseRequired} and SectionCode ne ${args.currentSection} `
        )
      }
    }
  }
  
  /** Active */
  if (args.activeFilter && args.activeFilter !== undefined) {
    filters.push(
      `StatusCode ne '${STATUS_CODE.SUBMITTED}'
       and StatusCode ne '${STATUS_CODE.REOPENED}'
        and StatusCode ne '${STATUS_CODE.RESOLVED}'
         and StatusCode ne '${STATUS_CODE.CLOSED}' 
         and StatusCode ne '${STATUS_CODE.SAVED}' 
         and StatusCode ne '${STATUS_CODE.CANCELED}'`
    )
  }
  if (args.hasCanceledClosedAndResolved === false) {
    filters.push(
      `StatusCode ne '${STATUS_CODE.RESOLVED}'
       and StatusCode ne '${STATUS_CODE.CLOSED}' 
       and StatusCode ne '${STATUS_CODE.CANCELED}' 

         `
    )
  }
  /** Assigned To Me */
  /** Assigned To Other */
  if (args.customerActionRequiredFilter && args.customerActionRequiredFilter !== null) {
    filters.push(`CustomerActionRequired eq ${args.customerActionRequiredFilter}`)
  }

  if (args.customerActionRequiredThreeDaysFilter) {
    const threeDaysAgo = new Date()
    threeDaysAgo.setDate(threeDaysAgo.getDate() - 3)
    filters.push(`CustomerActionRequiredDate gt ${threeDaysAgo.toISOString()} `)
  }
  if (
    args.inquiryTypeFilter &&
    args.inquiryTypeFilter !== (ALL_SELECT_VALUE_STRING as InquiryType)
  ) {
    filters.push(`InquiryType eq '${args.inquiryTypeFilter}'`)
  }

  if (args.customerActionRequiredSevenDaysFilter) {
    const threeDaysAgo = new Date()
    threeDaysAgo.setDate(threeDaysAgo.getDate() - 3)

    const sevenDaysAgo = new Date()
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)
    filters.push(
      `CustomerActionRequiredDate  lt ${threeDaysAgo.toISOString()} and CustomerActionRequiredDate ge ${sevenDaysAgo.toISOString()}`
    )
  }

  if (args.customerActionRequiredTenDaysFilter) {
    const sevenDaysAgo = new Date()
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)

    const tenDaysAgo = new Date()
    tenDaysAgo.setDate(tenDaysAgo.getDate() - 10)
    filters.push(
      `CustomerActionRequiredDate lt ${sevenDaysAgo.toISOString()} and CustomerActionRequiredDate ge ${tenDaysAgo.toISOString()}`
    )
  }

  if (args.customerActionRequiredMoreThanTenDaysFilter) {
    const moreThanTenDaysAgo = new Date()
    moreThanTenDaysAgo.setDate(moreThanTenDaysAgo.getDate() - 10)
    filters.push(`CustomerActionRequiredDate le ${moreThanTenDaysAgo.toISOString()} `)
  }

  if (args.pendingActionOutsideFilter && args.pendingActionOutsideFilter !== null) {
    filters.push(`PendingActionOutside eq ${args.pendingActionOutsideFilter} `)
  }
  if (args.needToWorkFilter && args.needToWorkFilter !== null) {
    filters.push(`CustomerActionRequired eq false and PendingActionOutside eq false`)
  }
  if (args.pendingActionOutsideThreeDaysFilter) {
    const threeDaysAgo = new Date()
    threeDaysAgo.setDate(threeDaysAgo.getDate() - 3)
    filters.push(`PendingActionOutsideDate gt ${threeDaysAgo.toISOString()}`)
  }

  if (args.pendingActionOutsideSevenDaysFilter) {
    const threeDaysAgo = new Date()
    threeDaysAgo.setDate(threeDaysAgo.getDate() - 3)

    const sevenDaysAgo = new Date()
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)
    filters.push(
      `PendingActionOutsideDate lt ${threeDaysAgo.toISOString()} and PendingActionOutsideDate ge ${sevenDaysAgo.toISOString()}`
    )
  }

  if (args.pendingActionOutsideTenDaysFilter) {
    const sevenDaysAgo = new Date()
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)

    const tenDaysAgo = new Date()
    tenDaysAgo.setDate(tenDaysAgo.getDate() - 10)
    filters.push(
      `PendingActionOutsideDate lt ${sevenDaysAgo.toISOString()} and PendingActionOutsideDate ge ${tenDaysAgo.toISOString()}`
    )
  }

  if (args.pendingActionOutsideMoreThanTenFilter) {
    const moreThanTenDaysAgo = new Date()
    moreThanTenDaysAgo.setDate(moreThanTenDaysAgo.getDate() - 10)
    filters.push(`PendingActionOutsideDate le ${moreThanTenDaysAgo.toISOString()}`)
  }

  /** Response Requested and Response Pending*/

  /** Return From MPF and Elevate To MPF*/
  if (args.returnedFromMPF) {
    const statusFilter = MPF_ACTIVE_INQUIRY_KPI.filter((value) => !value.includes('CSS'))
      .map((status) => `PreviousStatusCode eq '${status}'`)
      .join(' or ')
    filters.push(`CurrentlyServicingBy eq 'CSS' and (${statusFilter})`)
  }
  if (args.elevatedToMPF) {
    filters.push(`CurrentlyServicingBy eq 'MPF'`)
    filters.push(`ServicingBy eq 'CSS'`)
  }
  if (args.statusCodesFilter && args.statusCodesFilter.length > 0) {
    const terms = args.statusCodesFilter.map((s) => `StatusCode eq '${s}'`)
    filters.push(or(...terms))
  }

  if (args.statusCodesOmittedFilter) {
    for (const statusCode of args.statusCodesOmittedFilter) {
      filters.push(`StatusCode ne '${statusCode}'`)
    }
  }
  if (args.myInquiries) {
    filters.push(`(ItemCreatedBy eq '${args.myInquiries}' or Customer eq '${args.myInquiries}') `)
    if (args.savedFilter)
      filters.push(`(ItemCreatedBy eq '${args.myInquiries}' and StatusCode eq 'SAVED' )`)
    else filters.push(`StatusCode ne 'SAVED'`)
  }
  if (args.savedFilter === false) {
    filters.push(`StatusCode ne 'SAVED'`)
  }
  filters.push('IsDeleted eq false')
  const filter = and(...filters)
  return filter
}

const getInquiryCount = async (args: InquiryFetchArgs): Promise<InquiryCount[]> => {
  const list = args.isViewApplied
    ? await mpfRViewsHttp().getview(VIEW_NAME)
    : await mpfRListsHttp().getList(LIST_NAME)
  const filter = constructInquiryFilter(args, args.isViewApplied)

  if (args?.groupByArgs && args?.selectArgs) {
    const items = await list
      .query()
      .filter(filter)
      .select(...(args?.selectArgs || ''))
      .groupBy(...(args?.groupByArgs || ''))
      .count(COLUMN_NAMES.InquiryGUID)
      .get()

    return items
  } else {
    const items = await list
      .query()
      .filter(filter)
      .select(COLUMN_NAMES.InquiryGUID)
      .count(COLUMN_NAMES.InquiryGUID)
      .get()

    return [...items] as InquiryCount[]
  }
}

const getInquiryCategoryCounts = async (args: any): Promise<any> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)

  const filter = constructInquiryFilter(args)

  const formattedCategories = await list
    .query()
    .filter(filter)
    .select(COLUMN_NAMES.InquiryGUID, COLUMN_NAMES.CategoryCode)
    .groupBy(COLUMN_NAMES.CategoryCode)
    .count(COLUMN_NAMES.InquiryGUID)
    .get()

  return formattedCategories.sort((a, b) => b.InquiryGUID_count - a.InquiryGUID_count)
}

const getTotalByMonthsCounts = async (args: any): Promise<any> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = constructInquiryFilter(args)
  const formattedTotals: any = []

  let currentMonth = new Date().getMonth()
  let currentYear = new Date().getFullYear() - 1
  const overallSummaryList: any[] = []

  for (let i = 0; i < 12; i++) {
    if (args?.yearFilter === -1) {
      currentMonth++
      if (currentMonth === 12) {
        currentMonth = 0
        currentYear++
      }
      overallSummaryList.push([Number(currentMonth), Number(currentYear)])
    } else {
      overallSummaryList.push([Number(i), Number(args?.yearFilter)])
    }
  }

  for (const overallSummary of overallSummaryList) {
    const firstDay: any = new Date(overallSummary[1], overallSummary[0], 1)
    const lastDay: any = new Date(overallSummary[1], overallSummary[0] + 1, 0)

    const submittedItems = await list
      .query()
      .filter(
        filter +
          ` and StatusCode eq 'SUBMITTED' and ItemModified ge ${firstDay.toISOString()} and ItemModified le ${lastDay.toISOString()}`
      )
      .select(COLUMN_NAMES.InquiryGUID)
      .count(COLUMN_NAMES.InquiryGUID)
      .get()

    const resolvedItems = await list
      .query()
      .filter(
        filter +
          ` and (StatusCode eq 'RESOLVED' or StatusCode eq 'CLOSED') and ResolvedDate ge ${firstDay.toISOString()} and ResolvedDate le ${lastDay.toISOString()}`
      )
      .select(COLUMN_NAMES.InquiryGUID)
      .count(COLUMN_NAMES.InquiryGUID)
      .get()

    const reopenedItems = await list
      .query()
      .filter(
        filter +
          ` and StatusCode eq 'REOPENED' and ItemModified ge ${firstDay.toISOString()} and ItemModified le ${lastDay.toISOString()}`
      )
      .select(COLUMN_NAMES.InquiryGUID)
      .count(COLUMN_NAMES.InquiryGUID)
      .get()

    formattedTotals.push({
      month: overallSummary[0],
      reopenedCount: reopenedItems[0]?.InquiryGUID_count,
      resolvedCount: resolvedItems[0]?.InquiryGUID_count,
      submittedCount: submittedItems[0]?.InquiryGUID_count,
      year: overallSummary[1],
    })
  }

  return formattedTotals
}

const getInquiryDistinctValues = async (
  args: InquiryFetchArgs
): Promise<Map<string, number[] | string[]>[]> => {
  const fieldNames = args?.distinctFiltersToQuery ?? []
  const list = args.isViewApplied
    ? await mpfRViewsHttp().getview(VIEW_NAME)
    : await mpfRListsHttp().getList(LIST_NAME)
  const filter = constructInquiryFilter(args, args.isViewApplied)
  const doOneQuery = async (fieldName) => {
    let query = list.query().filter(filter).select(fieldName).distinct(true)

    if (!args.isViewApplied) {
      query = query.expand('AssignedTo')
    }

    const result = await query.get()

    return [...result].map((r) => r[fieldName])
  }

  const queries = fieldNames.map((field) => doOneQuery(field))
  const allResults = await Promise.all(queries)
  const uniqueResults = allResults.map((results) => {
    return [...new Set(results)]
  })

  const returnMap = new Map<string, number[] | string[]>()

  if (uniqueResults.length === fieldNames.length) {
    for (let i = 0; i < fieldNames.length; i++) {
      returnMap.set(fieldNames[i], uniqueResults[i])
    }
  }
  return [returnMap]
}

const getInquiryStatusCounts = async (args: InquiryFetchArgs): Promise<InquiryStatusCount[]> => {
  const list = args.isViewApplied
    ? await mpfRViewsHttp().getview(VIEW_NAME)
    : await mpfRListsHttp().getList(LIST_NAME)
  const filter = constructInquiryFilter(args, args.isViewApplied)

  const items = await list
    .query()
    .filter(filter)
    .select(COLUMN_NAMES.StatusCode, COLUMN_NAMES.InquiryGUID)
    .groupBy(COLUMN_NAMES.StatusCode)
    .count(COLUMN_NAMES.InquiryGUID)
    .get()

  return [...items] as InquiryStatusCount[]
}

const addOrUpdateInquiry = async (item) => {
  try {
    const list = await mpfRListsHttp().getList(LIST_NAME)
    const result = await list.addOrUpdateItem(item)
    return result
  } catch (error) {
    console.error('An error occurred while adding or updating the inquiry:', error)
    throw new Error('Failed to add or update inquiry')
  }
}
const deleteInquiry = async (ekey, eTag) => {
  try {
    const list = await mpfRListsHttp().getList(LIST_NAME)
    const result = await list.deleteItem(ekey, eTag)
    return result
  } catch (error) {
    console.error('An error occurred while adding or updating the inquiry:', error)
    throw new Error('Failed to add or update inquiry')
  }
}

const formatInquiryID = (Id: number, DoDNumber: string) => {
  const parsedDoDNumber = parseInt(DoDNumber)
  let formattedId = Id.toString()
  let IdLength = formattedId.length

  while (IdLength < 7) {
    formattedId = '0' + formattedId
    IdLength++
  }

  return `${parsedDoDNumber}-${formattedId}`
}

export {
  COLUMN_NAMES,
  type Inquiry,
  type InquiryCategoryCount,
  type InquiryCount,
  type InquiryFetchArgs,
  type InquiryFiles,
  type InquiryStatusCount,
  type IsForSelf,
  LIST_NAME,
  type PersonDetails,
  addOrUpdateInquiry,
  deleteInquiry,
  formatInquiryID,
  getInquiries,
  getInquiryCategoryCounts,
  getInquiryCount,
  getInquiryDistinctValues,
  getInquiryStatusCounts,
  getInquiryViews,
  getTotalByMonthsCounts,
  type month,
}
